import React, { useEffect, useRef, useState } from 'react'
import * as image from "../../../src/resources/images";
import { datesorting, getCapitalized, getChildrenSort, getName, getProfileName, getToolTip, replaceName, textTrim, timeAgo } from '../../utils/helper';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { PATHS } from '../../utils';

const SctNotification = () => {
    const dispatch = useDispatch();
    const notificationRef = useRef();
    const history = useHistory();
    const {
        loggedInUser,
        defaultChildData,
        notificationCount,
        notificationDetail,
    } = useSelector((state) => state.collections);

    const [isNotification, setIsNotification] = useState(false);


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (notificationRef && notificationRef.current && notificationRef.current.contains(event.target)) {
                // console.log("handleClik Insise ##");
            } else {
                // console.log("handleClik outSide #", event.target, viewRewardRef);
                setIsNotification(false);
            }
        };
        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);

    const gotoNotification = (notficationData)=>{
        //  history.push({
        //             pathname: PATHS.STR_COURSE_DETAIL + "/" + notficationData?.courseId + "/" + notficationData?.activityId,
        //             state: { course: "" }
        //         })  
        // window.location.reload();
        window.location.href = `${PATHS.STR_COURSE_DETAIL}/${notficationData?.courseId}/${notficationData?.activityId}`;
    
    }

    // console.log("SctNotification : ", notificationDetail);
    return (
        <div className='mynotification mr-3 pointer' ref={notificationRef}>
            <p className='P1'
                data-toggle="modal"
                data-target="#ProfileMenunotification"
                data-bs-toggle="modal"
                data-bs-auto-close="false"
                aria-expanded="false"
                onClick={() => setIsNotification(!isNotification)}
            >
                <img src={image.notification_icon}    
                />
                {notificationDetail?.records?.length > 0 &&
                    <span className='notificationcount'>{notificationCount?.records[0]}</span>
                }
                
            </p>
            {isNotification && notificationDetail?.records?.length > 0 && (
                 <div className='drop' >
                <div className="ProfileMenuPopup">
                    <div
                        className="modal fade"
                        id="ProfileMenunotification"
                        role="dialog"
                        backdrop="static">
                        <div className="sctmessagelist">
                            <ul>
                                {   notificationDetail?.records?.length > 0 &&
                                    datesorting(notificationDetail?.records)?.reverse()?.map((data) => (
                                    <li onClick={()=>gotoNotification(data)} 
                                        className={`${data?.status === "PENDING" ? "Seennotification" : ""}`}>
                                        <p className="flextwo"> 
                                         <img src={image.solar_notification} className="mr-3" />
                                           <div className='notification_msg'>
                                           <h3 className={`h-3  ${data?.title === "Booster" ? "booster_ref" : "booster_ref reflection"}`}>{data?.title ? data?.title : "Title"}</h3>
                                           <h4 className=''> {data?.courseName}</h4>
                                            <h5>{replaceName(loggedInUser, data?.name)}</h5>
                                            <p 
                                                dangerouslySetInnerHTML={{
                                                    __html: `${data?.description && replaceName(loggedInUser, data?.description)?.slice(0, 96)}${data?.description?.length > 96 ? "..." : "."}`,
                                                }}
                                                className='p2'
                                            />
                                            </div>
                                        </p>
                                        <span className='time_Now'>{timeAgo(data?.createdDate)}</span>
                                    </li>
                                ))}

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            )}
           
        </div>
    )
}
export default SctNotification;